var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$(document).on('mouseup', '.rb-extras-wrapper div.tflex-column-ns[data-v-67daa9] button.rb-btn-qty-minus', function(){
  $('.rb-extras-wrapper div.tflex-column-ns[data-v-67daa9] button.rb-btn-qty-plus').removeClass("tdisabled").removeAttr("disabled");
});

$(document).on('click', '.rb-extras-wrapper div.tflex-column-ns[data-v-67daa9] button.rb-btn-qty-plus', function(){
    checkQty();
});

$(document).on('change', '.rb-extras-wrapper div.tflex-column-ns[data-v-67daa9] input.rb-input', function(){
    checkQty();
});

var introhtml = '<div id="step1content"><div id="bundle-intro"><div class="rb-container">	<h1>Build Your Hydration Kit</h1>	<div id="bundle-intro-steps">		<div class="bundle-intro-step"><div class="bundle-intro-image"><img src="https://cdn.shopify.com/s/files/1/0684/9639/2487/files/icon_caps.png" alt="Step 1" /></div><div class="bundle-intro-step-name">Step 1</div><div class="bundle-intro-step-desc">Pick Your PushCaps</div>		</div>		<div class="bundle-intro-step"><div class="bundle-intro-image"><img src="https://cdn.shopify.com/s/files/1/0684/9639/2487/files/icon_caps_bottle.png" alt="Step 2" /></div><div class="bundle-intro-step-name">Step 2</div><div class="bundle-intro-step-desc">Add a Karma Reusable Bottle</div>		</div>		<div class="bundle-intro-step"><div class="bundle-intro-image"><img src="https://cdn.shopify.com/s/files/1/0684/9639/2487/files/icon_clock.png" alt="Step 3" /></div><div class="bundle-intro-step-name">Step 3</div><div class="bundle-intro-step-desc">Enjoy & Save</div>		</div>	</div></div></div><h2 id="pick-headline">Pick Your PushCaps</h2></div>';

$( document ).ready(function() {
  $('.rb-extras-wrapper div.tflex-column-ns[data-v-67daa9] button.rb-btn-qty-plus span').text("Add");
  $('.rb-extras-wrapper div.tflex-column-ns[data-v-67daa9] button.rb-btn-qty-minus span').text("Remove");
  $('#recharge-bundles').before(introhtml);
});

function checkQty(){
    var qty = $('.rb-extras-wrapper div.tflex-column-ns[data-v-67daa9] input.rb-input').val();
    if(qty == 1){
      $('.rb-extras-wrapper div.tflex-column-ns[data-v-67daa9] button.rb-btn-qty-plus').addClass("tdisabled").attr("disabled", "disabled");
    }
}

$(document).on('change', '.rb-frequency select', function(){
  var freq = $(this).find(":selected").text();
  if (freq == "Only once"){
    $('.rb-item-content').addClass('onetime');
  }
  else{
    $('.rb-item-content').removeClass('onetime');
  }
});

$(document).on('click', '.rb-btn', function(){
  if( !$(this).is(":disabled") && $(this).text() == "Continue" ){
    $('#step1content').fadeOut(1000);
  }
});